import { render, staticRenderFns } from "./public-fl223-protocol.vue?vue&type=template&id=4c70206c&"
import script from "./public-fl223-protocol.vue?vue&type=script&lang=js&"
export * from "./public-fl223-protocol.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c70206c')) {
      api.createRecord('4c70206c', component.options)
    } else {
      api.reload('4c70206c', component.options)
    }
    module.hot.accept("./public-fl223-protocol.vue?vue&type=template&id=4c70206c&", function () {
      api.rerender('4c70206c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/fl223/partials/public-fl223-protocol.vue"
export default component.exports